import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
          justifyStart
          alignCenter
          textCenter
        >
          <CFView mt="10%" w="100%">
            <CFImage
              w="90%"
              src={mobileHeroText}
              alt="Komo Sushi Japanese Restaurant hero text"
              zIndex={98}
            />
          </CFView>
          <CFView pulsate mt="15px">
            <OrderPickupButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="92vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) bottom/ cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          <CFView column justifyCenter alignStart ml="5vw">
            <CFImage
              w="48vw"
              maxWidth="550px"
              src={heroText}
              alt="Komo Sushi Japanese Restaurant hero text"
              zIndex={98}
            />
            <CFView pulsate w="25vw" mt="15px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
